import { createStore } from './index.js';

// Get initial profile name from window.__USER__ if available
const initialProfileName = typeof window !== 'undefined' ? window.__USER__?.name || null : null;

// Use preloaded state from window if available (browser), otherwise empty object
const preloadedReduxState =
  typeof window !== 'undefined' && (window as any).__REDUX_STATE__
    ? (window as any).__REDUX_STATE__
    : {};

// Add the profile name to the preloaded state for the auth slice if available
const preloadedState = {
  ...preloadedReduxState,
  auth: {
    ...((preloadedReduxState as any).auth || {}),
    // If we have a profile name from window.__USER__, create a minimal user object with it
    ...(initialProfileName ? {
      user: {
        ...(((preloadedReduxState as any).auth?.user) || {}),
        user_metadata: {
          ...(((preloadedReduxState as any).auth?.user?.user_metadata) || {}),
          display_name: initialProfileName
        }
      },
      status: 'succeeded' // Set status to succeeded since we have a user
    } : {})
  }
};

export const store = createStore(preloadedState);
